import React from 'react';

import { Box, HStack, Stack } from '@chakra-ui/react';
import map from 'lodash/map';

export interface OrderedListProps {
  list: string[];
}

export const OrderedList = (props: OrderedListProps) => {
  return (
    <Stack>
      {map(props.list, (o, index) => (
        <HStack>
          <Box>{index + 1}.</Box>
          <Box>{o}</Box>
        </HStack>
      ))}
    </Stack>
  );
};
